import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShoppingBag, ArrowLeft } from 'lucide-react';

const CerebrixExchange: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white p-6">
      {/* Encabezado */}
      <div className="mb-8">
        <button
          onClick={() => navigate('/dashboard')}
          className="flex items-center text-primary hover:text-primary/80 transition-colors mb-4"
        >
          <ArrowLeft className="h-5 w-5 mr-2" />
          Volver al Dashboard
        </button>
        <h1 className="text-4xl font-bold text-primary">
          Tienda de Cerebrix
        </h1>
        <p className="text-gray-600 mt-2">
          ¡Próximamente podrás canjear tus Cerebrix por productos increíbles!
        </p>
      </div>

      {/* Contenido Principal */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-4xl mx-auto"
      >
        <div className="bg-white rounded-xl p-8 shadow-lg border border-primary/10">
          <div className="flex flex-col items-center text-center space-y-6">
            <div className="bg-primary/10 p-6 rounded-full">
              <ShoppingBag className="h-16 w-16 text-primary" />
            </div>
            
            <h2 className="text-2xl font-bold text-gray-800">
              ¡Estamos preparando algo especial para ti!
            </h2>
            
            <p className="text-gray-600 max-w-2xl">
              Muy pronto podrás canjear tus Cerebrix por productos digitales y físicos 
              increíbles. Sigue aprendiendo y acumulando Cerebrix para estar listo 
              cuando abramos nuestra tienda.
            </p>

            <div className="bg-gray-50 p-6 rounded-lg w-full mt-8">
              <h3 className="text-xl font-semibold text-gray-700 mb-4">
                Lo que podrás encontrar:
              </h3>
              <ul className="text-left space-y-3 text-gray-600">
                <li className="flex items-center">
                  <span className="mr-2">🎮</span>
                  Juegos educativos exclusivos
                </li>
                <li className="flex items-center">
                  <span className="mr-2">📚</span>
                  Libros y contenido premium
                </li>
                <li className="flex items-center">
                  <span className="mr-2">🎁</span>
                  Productos físicos sorpresa
                </li>
                <li className="flex items-center">
                  <span className="mr-2">🏆</span>
                  Recompensas especiales
                </li>
              </ul>
            </div>

            <button
              onClick={() => navigate('/dashboard')}
              className="bg-primary text-white px-8 py-3 rounded-full hover:bg-primary/90 transition-colors mt-8"
            >
              Volver al Dashboard
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default CerebrixExchange;
